$(document).ready(function () {
	$(".js-work-carousel").owlCarousel({
		center: true,
		loop: true,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 4000,
		autoplayHoverPause: true,
		smartSpeed: 600,
		stagePadding: 0,
		responsive: {
			0: {
				items: 1,
				margin: 12,
				stagePadding: 40,
			},
			768: {
				items: 1,
				margin: 20,
				stagePadding: 120,
			},
			1200: {
				items: 1,
				margin: 24,
				stagePadding: 220,
			},
			1400: {
				items: 1,
				margin: 28,
				stagePadding: 280,
			},
		},
	});
});
